import React from "react";

interface WhatItMeansSectionProps {
  title: string;
  description: string;
}
const WhatItMeansSection: React.FC<WhatItMeansSectionProps> = ({
  title,
  description = "",
}) => {
  return (
    <div className="px-4">
      <div className="text-base font-semibold text-text-primary mb-2">
        {title}
      </div>
      <div
        className="text-sm font-normal text-text-quaternary mb-2"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </div>
  );
};

export default WhatItMeansSection;
